import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';

export const HeaderContainer = styled.div`
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 25px;

  a,
  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
    /* color: inherit; */
  }

  @media screen and (max-width: 800px) {
    height: 60px;
    padding: 10px;
    margin-bottom: 20px;
  }
`;

export const LogoContainer = styled(Link)`
  height: 100%;
  width: 50%;
  padding: 25px;
  display: flex;
  flex-direction: row;

  .logo {
    top: -110px;
    left: -200px;
    position: absolute;
    transform: scale(0.2);
  }

  ${'' /* @media screen and (max-width: 600px) {
    width: 50px;
    padding: 0;
    .logo {
      left: -100px;
      opacity: 0.5;
    }
  } */
  }
`;

export const OptionsContainer = styled(Box)`
  width: 50%;
  height: 100%;
 
  align-items: center;
  justify-content: flex-end;

  @media screen and (max-width: 800px) {
    width: 80%;
  }
`;

export const OptionLink = styled(Link)`
  padding: 15px 15px;
  margin-top: 20px;
  cursor: pointer;
  z-index: 1;
  color: black;
  :hover {
    font-weight: bold;
    color: #f40012;
  }

  @media screen and (max-width: 800px) {
    text-align: center;
    font-size: 12px;
    padding: 5px 5px;
  }
`;

export const BrandName = styled.div`
  font-weight: bolder;
  font-size: 25px;

  ${'' /* @media screen and (max-width: 800px) {
    font-size: 15px;
    text-align: center;
  } */
  }
`;
